<template>
  <div id="content" class="where_to_innovate_finder">
    <ConfirmModal :dialogVisible='confirmBack' @close="confirmBack = false" @confirmed="backIsConfirm($event)" message="Are you sure you want to continue?<br/>This will erase your current conversation history." ></ConfirmModal>

    <ConfirmModal :dialogVisible='confirmDataroom' @close="confirmDataroom = false" @confirmed="confirmAndGoToSTepOneCB($event)" message="Are you sure you want to continue without uploading consumer or market insights?<br/>These help generate more relevant innovation topics." ></ConfirmModal>
    <DataRoomModal :dialogVisible='dataroommalodal' @endOfDataroomUpload="closeDataRoomModal($event)"></DataRoomModal>
    <div class="ai_loader" v-if="pearlAI_reflexion">
      <div class="ai_loader_in">
        <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
        <div class="ai_loader_text" v-html="ai_loader_text"></div>
      </div>
    </div>
    <div class="content_div" v-if="step == 0">
      <div class="inner ">
        <div class="title aimode_ttile" v-if="messages.length <= 1">
            <span>LET’S START WITH BUSINESS INTELLIGENCE </span><span class="aimode">AI mode</span>
        </div>
        <div class="firstmessage">
          <div class="subtitle">Upload consumer & market insights to generate relevant opportunities</div>
        </div>

        <div class="bandeau_data_room">
          <div class="buttons_dataroom">
            <button type="button" name="button" class="uploadDocDataRoomButton" @click="dataroommalodal = true"><span>UPLOAD YOUR DOCUMENTS</Span>        <img :src="require('@/assets/uploadArrow.svg')" alt=""></button>
            <button type="button" name="button" class="continueButton" @click="confirmAndGoToSTepOne()"><span>CONTINUE</Span>        <img :src="require('@/assets/continueArrow.svg')" alt=""></button>
          </div>
          <div class="dataroom_size">
            {{dataroom_size}} DOCUMENT<span v-if='dataroom_size > 1'>S</span> IN DATA ROOM
          </div>

        </div>
      </div>
    </div>
    <div class="content_div" v-if="step == 1">
      <div class="header withDataRoom">
        <a href="/pearlAI_dataroom" class="goToDataroom tooltip-bottom" data-tooltip="Refresh your company’s consumer and market insights in your data room" target="_blank">
          <span>data room</span>
          <span class="dataroom_size">{{dataroom_size}}</span>
        </a>
      </div>
      <div class="inner ">
        <div class="" v-if="sessionId && debugerPeople.includes(userInfo._id.$oid)">
          <small>Session ID : {{sessionId}}</small>
        </div>
        <!-- <div class="title" v-if="messages.length <= 1">
            'Where to innovate' finder
        </div> -->
        <div class="title" v-if="messages.length >= 1">
          YOUR BUSINESS OPPORTUNITIES
        </div>
        <div class="firstmessage" v-if="messages.length == 0">
            <div class="subtitle"><span v-if="userInfo">Hi {{userInfo.firstname}}, t</span><span v-else>T</span>ell us about the main challenge or opportunity area you want to explore.<br/>
 PearlAI will identify key innovation topics and potential partners for you.</div>
            <div class="first_prompter">
              <div class="first_prompter_inside">
                <textarea name="name" rows="4" cols="80" class="my_prompt" v-model="prompt" placeholder="I need to explore innovation in sustainable packaging" @keyup.enter="handleKeyup"></textarea>
                <button type="button" @click="sendMessage()"  class="sendPearlAiBtn" name="button">
                  <img :src="require('@/assets/sendPearlAI.svg')" alt="">
                </button>
              </div>

              <small class="legend_first_prompt">Please ensure relevant market insights and business intelligence are uploaded into your data room. They will be exclusively accessible to the users of your company. You can delete them anytime.</small>
            </div>
        </div>

        <div class="messages" v-else>
            <div class="one_message" :class="msg.type"  v-for="(msg,m) in messages" :key="m" :ref="'message-' + m" >
              <div class="message_container" v-if="msg.type == 'bot' || msg.type == 'user'">
                <div class="inner">
                  <div v-html="msg.content"></div>
                </div>
              </div>


            <div  v-if="msg.type == 'topic' || msg.type == 'topicRefined'">

              <div class="message_container" v-if="msg.type == 'topic' && msg.content.length > 0">
                <div class="inner">
                  <div>Let's start with identifying some topics to work with. This is what I found from my proprietary research:</div>
                </div>
              </div>
              <div class="message_container" v-else-if="msg.type == 'topicRefined' && msg.content.length > 0">
                <div class="inner">
                  <div>There are refined topics</div>
                </div>
              </div>
              <div class="message_container" v-else>
                <div class="inner">
                  <div><strong>We couldn’t identify any relevant innovation topics based on your input.</strong><br/>Try adding more specific market trends, consumer needs, or business insights to guide the analysis.
                  </div>
                </div>
              </div>
              <div class="message_topics_found" v-if="msg.content.length > 0">
                <span class="topicsListTitele" v-if="msg.type == 'topic'">Innovation topics</span>
                  <span class="topicsListTitele" v-if="msg.type == 'topicRefined'">Refined innovation topics</span>
                <div class="list_of_topics">
                  <div class="one_topic" v-for="(topic, t) in msg.content" :key="t">
                    <div class="one_topic_interest high" v-if="topic.score >= 8">
                          STRONGEST FIT
                    </div>
                    <div class="one_topic_interest medium" v-else-if="topic.score >= 5">
                          STRONG FIT
                    </div>
                    <div class="one_topic_interest low" v-else-if="topic.score != -1">
                          MODERATE FIT
                    </div>
                    <div class="one_topic_interest gnkow" v-else>
                          GENERAL KNOWLEDGE
                    </div>

                    <div class="one_topic_title">
                      {{ topic.topicTitle }}
                    </div>
                    <div class="one_topic_desc">
                      {{topic.description}}
                    </div>
                    <div class="one_topic_source">
                      SOURCE : {{topic.source}}
                    </div>
                    <div class="one_topic_action">
                        <button type="button" name="button" class="refine_button tooltip-bottom"  @click="askForTopicRefine(topic)">Refine</button>
                        <button type="button" name="button" class="select_button tooltip-bottom" @click="promptSelect(topic)">Select</button>
                    </div>
                  </div>
                </div>

              </div>

            </div>

                <div  v-if="msg.type == 'brief' || msg.type == 'briefRefined'">
                    <div class="message_container">
                      <div class="inner">
                        <div>Of course, here is the <span v-if="msg.type == 'briefRefined'">refined </span>brief for the topic "{{msg.content.title}}" as part of your challenge.</div>
                      </div>
                  </div>
                  <div class="message_brief" v-if="msg.content">
                    <div class="message_brief_title">
                        Your <span v-if="msg.type == 'briefRefined'">refined </span>brief for "{{msg.content.title}}"
                    </div>

                     <div class="message_brief_content">
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/search_field_1_problem_to_be_solved.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">PROBLEM TO BE SOLVED</span>
                        <div class="scouting_brief_item_content">
                          {{msg.content.description}}
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_assets.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">Assets required</span>
                        <div class="scouting_brief_item_content">
                            <ul v-if="msg.content.assets">
                              <li v-for="(item, i) in msg.content.assets" :key='i'>+ {{item}}</li>
                            </ul>

                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_reco_techno.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">recommended technologies</span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="msg.content.assets">
                            <li v-for="(item, i) in msg.content.recommended_technologies" :key='i'>+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_benef_client.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">Benefits for <span v-if="userInfo.entreprise">{{userInfo.entreprise}}</span><span v-else></span></span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="msg.content.company_benefits">
                            <li v-for="(item, i) in msg.content.company_benefits" :key='i'>+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_indu.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">Industries</span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="msg.content.industries">
                            <li v-for="(item, i) in msg.content.industries" :key='i' >+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_benef_end.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">benefits for end customer</span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="msg.content.customer_benefits">
                            <li v-for="(item, i) in msg.content.customer_benefits" :key='i'>+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="actions_on_brief">
                    <button class="refine_brief_button" type="button" @click="ask_for_brief_refine(msg.content.title)" name="button">Refine</button>

                      <button class="show_startups_button" type="button" @click="saveAndShowStartup(msg.content)" name="button">SAVE AS PROJECT</button>
                  </div>

                </div>


              </div>


            <div class="first_prompter" v-if="needs_prompt">
                <div class="first_prompter_inside">
                  <textarea name="name" rows="4" cols="80" class="my_prompt" v-model="prompt" @keyup.enter="sendMessage"></textarea>
                  <button type="button" @click="sendMessage()"  class="sendPearlAiBtn" name="button">
                    <img :src="require('@/assets/sendPearlAI.svg')" alt="">
                  </button>
                </div>
            </div>

            <div class="bandeau_back_info_session">
              <div class="backinfo_notice">
                <div class="footer_message_session_warning">

                  AI analysis available for this session only.<br/>
 You may select multiple topics, generate and save the brief, then return to this screen.
                </div>
              </div>
              <div class="backinfo_buttons">
                <button class="back_button" type="button" @click="confirmBack = true" name="button">BACK</button>

              </div>

            </div>



        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../tools/api';
import DataRoomModal from '@/components/DataRoomModal.vue'
import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import { toast } from 'vue-sonner'

export default {
  components: {
    ConfirmModal,
    DataRoomModal
  },
  name: 'WhereToInnovateFinder',
  data() {
    return {
      pageInfo: {
        mainTitle : "Targeting",
        subTitle : "Define the business opportunity",
      },
      sessionId: null,
      debugerPeople : ["64a2ae841e94ddfc32058c76","64a2ae841e94ddfc32058c76","66277502be2623f17e040bd5","64be5de5851dc5d20da0a6b5"],
      dataroommalodal:false,
      ai_loader_text : "Please wait while PearlAI ​​analyzes the data.",
      pearlAI_reflexion:false,
      apiUrl: process.env.VUE_APP_API_URL,
      prompt : "",
      dataroom_size:0,
      needs_prompt:false,
      first_message : true,
      userInfo:null,
      selectedTopic : null,
      messages : [],
      step:-1,
      topic_to_refine :null,
      confirmDataroom:false,
      next_action : null,
      confirmBack:false,
    }
  },
  methods:{
    backIsConfirm(v){
      if(v){
        this.messages = [];
        this.prompt = "";
        this.next_action= null;
        this.needs_prompt = true;
        this.first_message= true;
        this.ai_loader_text = "Please wait while PearlAI ​​analyzes the data.";
      }
      this.confirmBack = false;
    },
    closeDataRoomModal(v){
      if(v){
        this.dataroom_size = v;
      }
      else if(v === 0){
        this.dataroom_size = v;
      }
      this.dataroommalodal = false;
    },
    confirmAndGoToSTepOne(){
      if(this.dataroom_size == 0){
        this.confirmDataroom = true;
      }
      else{
        this.step = 1;
      }
    },
    confirmAndGoToSTepOneCB(ok){
      this.confirmDataroom = false;
      if(ok){
        this.step = 1;
      }
      else{
        this.step = 0;
      }
    },
    async saveAndShowStartup(brief){
      console.log(brief);
      var posted_data =
      {
        brief : brief,
        historique_message : this.messages,
        sessionId : this.sessionId,
        selectedTopic: this.selectedTopic,
        saved_as_project:true,
      };
      try {
        const response = await api.post(process.env.VUE_APP_API_URL+"/restrict/savePearlAIBrief", posted_data, {
              headers: {
                  'Content-Type': 'application/json',
              }
          });


          if(response?.data?.$oid){
            toast.success("Your brief has been successfully saved.")
            window.open(window.location.origin+'/where_to_innovate_index',"_blank");
          }
          else  toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

     } catch (e) {
       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
     }
    },
    addMessage(type,input) {
      this.messages.push({
        type: type,
        content: input
      });
      this.$nextTick(() => {
        var latestMessageRef = this.$refs[`message-${this.messages.length - 1}`];
        if (latestMessageRef) {
          latestMessageRef[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    },
    reloadDataRoom(){
      api.get(this.apiUrl+"/restrict/get_my_dataroom").then( (r) => {
        this.dataroom_size = r.data.makert_and_business_intelligence_files.length + r.data.priorities_and_goals_files.length;
        console.log(this.dataroom_size);
        if(this.dataroom_size == 0)this.step = 0;
        else this.step = 1;
        console.log(r);
      }).catch( (e) => {
        console.log(e);
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
    },
    handleKeyup(event) {
      if (event.key === 'Enter' && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.metaKey) {
        this.sendMessage();
      }
    },
    askForTopicRefine(topic){
      this.next_action = "refineTopic";
      this.topic_to_refine = topic;

      this.addMessage("bot","Sure, lets refine the topic "+topic.topicTitle+".<br/>Are there any specific elements that you want me to refine? ");
      this.needs_prompt = true;
    },
    ask_for_brief_refine(topicTitle){
      this.next_action = "refineBrief";
      this.addMessage("bot","Sure, lets refine your brief for "+topicTitle+".<br/>Are there any specific parts that you want me to refine?");
      this.needs_prompt = true;
    },
    async promptRefine(selected,prompt = ""){
      this.selectedTopic = selected;
      this.needs_prompt = false;
      var input = prompt;
      this.addMessage("user",input);
      this.ai_loader_text = "Upload your business and market insights to boost relevance."

      this.pearlAI_reflexion = true;
      try {
        const response = await api.post(process.env.VUE_APP_API_URL+"/restrict/refineTopics", {
              topicTitle: selected.topicTitle,
              sessionId: this.sessionId,
              prompt : prompt
          }, {
              headers: {
                  'Content-Type': 'application/json',
              }
          });

         var data = response.data;
         console.log(data);
         if (data.sessionId) {
             this.sessionId = data.sessionId;
         }
         this.addMessage("topicRefined",data.topics);


         this.pearlAI_reflexion = false;
         if(data.topics.length == 0){
            this.needs_prompt = true;
         }

     } catch (e) {
       console.log(e);
       this.addMessage("bot",'<strong>Something went wrong while processing your request.</strong><br/>Please try again in a few moments, or refresh the page if the issue continues.');


       this.needs_prompt = true;
       this.pearlAI_reflexion = false;
     }
     this.next_action = null;
     this.topic_to_refine = null;
    },
    async promptSelect(selected){
      this.selectedTopic = selected;
      this.needs_prompt = false;
      var input = "I select "+selected.topicTitle+". <br/>I need you to develop the brief for this topic.";
      this.addMessage("user",input);
      this.ai_loader_text = "We are generating your brief. Please wait."
      this.pearlAI_reflexion = true;
      try {
        const response = await api.post(process.env.VUE_APP_API_URL+"/restrict/processTopics", {
              topicTitle: selected.topicTitle,
              sessionId: this.sessionId
          }, {
              headers: {
                  'Content-Type': 'application/json',
              }
          });

         var data = response.data;
         console.log(data);
         if (data.sessionId) {
           this.sessionId = data.sessionId;
            this.addMessage("brief",data.brief);
            this.pageInfo.subTitle = "Generate innovation brief",
            this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
         }
         else{
              this.addMessage("bot",data);
         }

         this.pearlAI_reflexion = false;
     } catch (e) {
       console.log(e);
       this.addMessage("bot",'<strong>Something went wrong while processing your request.</strong><br/>Please try again in a few moments, or refresh the page if the issue continues.');

       this.pearlAI_reflexion = false;
     }
    },
    async promptRefineBrief(topicTitle,prompt = ""){
      this.needs_prompt = false;
      this.addMessage("user",prompt);
      this.ai_loader_text = "We are refining your brief. Please wait."
      this.pearlAI_reflexion = true;
      try {
        const response = await api.post(process.env.VUE_APP_API_URL+"/restrict/refineBrief", {
              topicTitle: topicTitle,
              prompt: prompt,
              sessionId: this.sessionId
          }, {
              headers: {
                  'Content-Type': 'application/json',
              }
          });

         var data = response.data;
         console.log(data);
         if (data.sessionId) {
           this.sessionId = data.sessionId;
            this.addMessage("briefRefined",data.brief);
            this.pageInfo.subTitle = "Generate innovation brief",
            this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
         }
         else{
              this.addMessage("bot",data);
         }

         this.pearlAI_reflexion = false;
         this.next_action= null;
         this.needs_prompt = false;
     } catch (e) {
       console.log(e);
       this.addMessage("bot",'<strong>Something went wrong while processing your request.</strong><br/>Please try again in a few moments, or refresh the page if the issue continues.');

       this.pearlAI_reflexion = false;
       this.next_action= null;
       this.needs_prompt = false;
     }
    },
    getFormattedContent(content) {
      // Replace newline characters with <br> tags
      return content.replace(/\n/g, '<br>');
    },
    async sendMessage() {
        let input = this.prompt;
        if (input.trim() === '') return;

        this.needs_prompt = false;

        this.prompt = "";
        if(this.first_message || this.next_action == "redochallenge"){
          //processChallenge to get list of topics
          this.addMessage("user",this.getFormattedContent(input));

          this.ai_loader_text = "Please wait. PearlAI is analysing your business opportunities."
          this.pearlAI_reflexion = true;
          try {
            const response = await api.post(process.env.VUE_APP_API_URL+"/restrict/processChallenge", {
              message: input,
                  sessionId: this.sessionId
              }, {
                  headers: {
                      'Content-Type': 'application/json',
                  }
              });

             var data = response.data;
             console.log(data);
             if (data.sessionId) {
                 this.sessionId = data.sessionId;
             }
             this.addMessage("topic",data.topics);

             this.first_message = false;
             this.pearlAI_reflexion = false;
             if(data.topics.length == 0){
                this.needs_prompt = true;
                this.next_action = "redochallenge";
             }

         } catch (e) {
           console.log(e);
           this.addMessage("bot",'Error: Could not get a response from the chatbot.');


           this.needs_prompt = true;
           this.next_action = "redochallenge";
           this.pearlAI_reflexion = false;
         }
        }
        else{
          if(this.next_action == "refineTopic"){
            console.log(input);
            this.promptRefine(this.topic_to_refine,input);
            this.next_action = null;
            this.topic_to_refine = null;
          }
          else{
            if(this.next_action == "refineBrief"){
              console.log(input);
              this.promptRefineBrief(this.topic_to_refine,input);
              this.next_action = null;
              this.topic_to_refine = null;
            }
          }
        }
    }
  },
  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
    this.reloadDataRoom();
    api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount").then( (r) => {
      this.userInfo = r.data;
      this.$store.commit('UPDATE_ROLE',r.data.role);
    }).catch( (e) => {
      console.log(e);
       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });


  },


}
</script>
<style scoped>

.where_to_innovate_finder{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
display: flex;
  flex-direction: column;
}

.firstmessage{
  margin-top:50px;
}
.title{
  color:#3783C5;
  font-size:24px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: "Inter";
  text-align:center;
}
.subtitle{
  color:#3783C5;
  font-size:20px;
  font-weight: 500;
  font-family: "Inter";
  text-align:center;
}

.first_prompter{
  text-align: center;
  max-width: min(900px, 100%);
  position:relative;
  margin:auto;
}
.first_prompter_inside{
  position:relative;
  width:100%;
}

.my_prompt{
  border: 1px solid #3783C5;
  border-radius: 10px;
  padding: 20px;
  resize: none;
  margin-top: 20px;
  color: #04246A;
  font-size: 15px;
  width: 100%;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  display:inline-block;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.sendPearlAiBtn{
  position:absolute;
  bottom:20px;
  right:20px;
}

.messages{

  margin-top:50px;
}

.messages .message_container{
  max-width: min(900px, 100%);
  position:relative;
  margin:auto;
}

.one_message.user .message_container .inner{
  background: #3783C5;
  padding: 25px;
  color: #FFF;
  font-size: 16px;
  border-radius: 15px;
  font-weight: 300;
  text-transform: none;
  width: 80%;
  margin-left: auto;
  margin-top:25px;
}
.one_message.brief .message_container .inner,
.one_message.briefRefined .message_container .inner,

.one_message.topicRefined .message_container .inner,
.one_message.topic .message_container .inner,
.one_message.bot .message_container .inner{
  background:#F1F6FB;
  padding: 25px;
  color: #3783C5;
  font-size: 16px;
  border-radius: 15px;
  font-weight: 500;
  text-transform: none;
  width: 80%;
  margin-right: auto;
  margin-top:25px;
}


.ai_loader{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,.2);
  width: 100%;
  display: block;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
}

.ai_loader_in{
  background: #FFF;
  padding: 20px;
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-content: center;
  align-items: center;

}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai_loader_in img{
  width:45px;
  animation: rotate 3s linear infinite;
}

.ai_loader_in .ai_loader_text{
  font-size: 18px;
  font-weight: 600;
  color:#04246A;
}

.legend_first_prompt{
  font-weight: 600;
  color:#04246A;
  text-align: left;
  display: block;
  font-size:13px;
}


.list_of_topics{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px 20px;
  margin-top: 50px;
  margin-bottom: 50px;
}

@media screen and (max-width:1600px){
  .list_of_topics{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width:1300px){
  .list_of_topics{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width:990px){
  .list_of_topics{
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}
.list_of_topics .one_topic{
  border: 1px solid #D1E8FB;
  border-radius: 10px;
  background: #FFF;
  padding: 30px 20px;
  position:relative;
  display: flex;
    flex-direction: column;
}

.one_topic_title{
  font-size: 15px;
  color: #3783C5;
  text-transform: uppercase;
  font-weight: 500;
}

.one_topic_desc{
  font-size: 15px;
  color: #04246A;
  margin-top: 10px;
  margin-bottom: 15px;
}
.one_topic_source{
  font-size: 13px;
  font-weight: 300;
  color: #04246A;
  margin-bottom: 25px;
}
.one_topic_action{
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: auto;
}

.refine_button{
  flex: 1;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px;
  color: #3783C5;
}
.select_button{
  flex: 1;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px;
  background: #3783C5;
  color: #FFF;
}

.back_button{
  flex: 1;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding:  10px 25px;
  background: #fff;
  color: #3783C5;
}
.show_startups_button{
  border:1px solid #3783C5;
  border-radius:25px;
  padding:10px 20px;
  background:#3783C5;
  color: #FFF;
    text-transform:uppercase;
}
.refine_brief_button{
  border:1px solid #3783C5;
  border-radius:25px;
  padding:10px 20px;
  background:#fff;
  color: #3783C5;
  text-transform:uppercase;
}

.one_topic_interest{
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
  text-transform: uppercase;
}
.one_topic_interest.gnkow{
  background:#F1F6FB;
  padding:4px 10px;
  font-size:14px;
  font-weight: 700;
  color:#3783C5;
  border-radius:20px;
}
.one_topic_interest.low{
  background:#FFE2E5;
  padding:4px 10px;
  font-size:14px;
  font-weight: 700;
  color:#FA5A7D;
  border-radius:20px;
}
.one_topic_interest.medium{
  background:#FFF4DE;
  padding:4px 10px;
  font-size:14px;
  font-weight: 700;
  color:#FFAA2A;
  border-radius:20px;
}
.one_topic_interest.high{
  background:#E7FFEF;
  padding:4px 10px;
  font-size:14px;
  font-weight: 700;
  color:#3AC851;
  border-radius:20px;
}


.message_brief{
  margin-top: 50px;
  margin-bottom: 50px;
  text-align: center;
  font-size: 22px;
  color:#04246A;
  font-weight: 600;
}

.message_brief_content{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;
  margin-top: 50px;
  margin-bottom: 50px;
  width: min(1500px,100%);
  margin-left: auto;
  margin-right: auto;
}


@media screen and (max-width:1200px){
  .message_brief_content{
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap:50px;
  }
}
.scouting_brief_item{
  width: 100%;
border: 1px solid #DDD;
border-radius: 10px;
position: relative;
}
.scouting_brief_item_img{
  width: 55px;
position: absolute;
top: -25px;
left: -25px;
}
.scouting_brief_item_title{
  position: absolute;
top: 0;
left: 50px;
background: #FFF;
transform: translateY(-50%);
padding-left: 10px;
padding-right: 10px;
padding-top: 6px;
padding-bottom: 6px;
font-size: 18px;
line-height: 18px;
font-weight: 600;
color: #3783C5;
text-transform: uppercase;
}

.scouting_brief_item_content{
  padding: 50px;
  font-size:16px;
  font-weight: 300;
  color:#000;
  text-align:left;
}
.header.withDataRoom{
  width:100%;
  display:block;
  margin-bottom: 25px;
}
.goToDataroom{
  background: #3783C5;
  color:#FFF;
  padding:10px 20px;
  float:right;
  display:flex;
  align-items: center;
  gap:10px;
  font-size:12px;
  text-transform: uppercase;
  border-radius:50px;
  font-weight: 500;
}

.goToDataroom .dataroom_size{
  background:#115AA4;
  padding:2px;
  border-radius: 50%;
  width:25px;
  height:25px;
  display:flex;
  font-size:12px;
  justify-content: center;
  align-items: center;
}

.scouting_brief_item_content ul,
.scouting_brief_item_content ul li{
  list-style-type: none;
  padding-left:0px;
}

.actions_on_brief{
  display:flex;
  justify-content: flex-end;
  align-items: flex-end;
  width:100%;
  gap:10px;
  text-transform:uppercase;
}

.topicsListTitele{
  text-align: center;
  width: 100%;
  display: block;
  font-weight: 600;
  margin-top: 20px;
  color: #04246A;
  font-size: 20px;
}

.footer_message_session_warning{
  text-align: center;
  font-weight: 600;
  font-size: 13px;

  color: #04246A;

}
.aimode_ttile{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
}
.aimode{
  font-size: 13px;
  padding:5px 10px;
  color:#B38D2F;
  font-weight:600;
  background:#FFEBB9;
  border-radius:25px;
}

.bandeau_back_info_session{
  padding:20px;
  border-radius:50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:50px;
  position:relative;
  flex-wra:wrap;
}

.bandeau_back_info_session .backinfo_notice{
  display:flex;
  gap:20px;
flex:1;
justify-content:center;
flex-wra:wrap;
}

.bandeau_back_info_session .backinfo_buttons{
position:absolute;
left:50px;
top:50%;
transform:translateY(-50%);
font-size: 13px;
    color: #04246A;
  font-weight:600;
  margin-right:auto;
}
@media screen and (max-width:1500px){
  .bandeau_back_info_session .backinfo_buttons{
  position:relative;
  right:auto;
  top:auto;
  transform:none;
  width:100%;
  text-align:center;
  display:block;
  margin-top:20px;
  left: 0;
  margin-bottom:20px;
}
.bandeau_back_info_session{
flex-direction:column-reverse;
}
}
@media screen and (max-width:1000px){
.bandeau_back_info_session .buttons_backinfo{
flex-direction:column-reverse;
}

}


.bandeau_data_room{
  background:#F1F6FC;
  padding:20px;
  border-radius:50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:50px;
  position:relative;
  flex-wra:wrap;
}
.bandeau_data_room .buttons_dataroom{
  display:flex;
  gap:20px;
flex:1;
justify-content:center;
flex-wra:wrap;
}

.bandeau_data_room .dataroom_size{
position:absolute;
right:50px;
top:50%;
transform:translateY(-50%);
font-size: 13px;
    color: #04246A;
  font-weight:600;
  margin-left:auto;
}
@media screen and (max-width:1500px){
  .bandeau_data_room .dataroom_size{
  position:relative;
  right:auto;
  top:auto;
  transform:none;
  width:100%;
  text-align:center;
  display:block;
  margin-top:20px;
}
.bandeau_data_room{
flex-direction:column;
}
}
@media screen and (max-width:1000px){
.bandeau_data_room .buttons_dataroom{
flex-direction:column;
}
.aimode_ttile{
flex-direction:column-reverse;
}
}
.continueButton{
  background:#FFF;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 7px 20px;
  color: #3783C5;
  display:flex;
  gap:10px;
  justify-content:center;
  align-items:center;
}
.uploadDocDataRoomButton{

display:flex;
gap:10px;
justify-content:center;
align-items:center;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 7px 20px;
  background: #3783C5;
  color: #FFF;
}

@media screen and (max-width:990px){
  .where_to_innovate_finder{
    padding-left:10px;
    padding-right:10px;
  }
  .where_to_innovate_finder .content_div{
    padding-left:20px;
    padding-right: 20px;
  }
}


[data-tooltip] {
  position: relative;
}
[data-tooltip]::after {
  background-color: #FFF;
  border-radius: 0.3rem;
  border:1px solid #D1E8FB;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: normal;
  z-index: 1;
  width:200px;
  color:#04246A;
  height:auto;
}

[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent #D1E8FB transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}

</style>
